import { useState, useEffect, RefObject } from 'react';
export function useHover(node: RefObject<HTMLElement>) {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    useEffect(() => {
        if (typeof window === 'undefined' || !node?.current) {
            return;
        }

        const canHover = window.matchMedia('(hover: hover)').matches;

        if (!canHover) {
            return;
        }

        const ref = node.current;

        ref.addEventListener('mouseenter', handleMouseEnter);
        ref.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            ref.removeEventListener('mouseenter', handleMouseEnter);
            ref.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [node]);

    return isHovered;
}
